<app-billing-banner></app-billing-banner>
<nb-layout class="cc layout">
  <!-- Breadcrumbs component -->
  <nb-layout-header class="layout-header" subheader>
    <div class="d-flex w-100" style="align-items: center">
      <div id="companyLogo" *ngIf="logo" style="cursor: pointer">
        <a [routerLink]="['/home']" (click)="onClickHandleLogo('HEADER_LOGO')">
          <img id="companyLogoImage" [src]="logo" alt="Logo" />
        </a>
      </div>
      <app-breadcrumbs-v2 *ngIf="userService?.userLoaded"></app-breadcrumbs-v2>
    </div>
    <app-paas-saas-switch
      *ngIf="!featureFlagService?.isSaaSCP && !featureFlagService?.hideUISwitch"
      class="mr-4"
    ></app-paas-saas-switch>
    <app-release-notification-panel></app-release-notification-panel>
    <!-- <app-alerts></app-alerts> -->
    <!-- <div
      *ngIf="clickupTicketUrl?.length"
      class="header-menu-item cursor-pointer"
      (click)="openHelpDashboard()"
      nbTooltip="Raise a Ticket ( ⌘ + / )"
      [nbTooltipDisabled]="!isHoveredHelp"
      (mouseover)="isHoveredHelp = true"
      (mouseout)="isHoveredHelp = false"
      [attr.data-action-id]="'raise-ticket-from-cp'"
    >
      <nb-icon
        pack="fci"
        [status]="isHoveredHelp ? 'control' : 'primary'"
        icon="help-icon"
      ></nb-icon>
    </div> -->
    <!--Search icon. Show only when local storage is supported on user's browser-->
    <div
      *ngIf="localStorageSupported && !featureFlagService.isSaaSCP"
      class="header-menu-item cursor-pointer"
      (click)="openSearch()"
      nbTooltip="Search (⌘ + E)"
      [nbTooltipDisabled]="!isHovered"
      (mouseover)="isHovered = true"
      (mouseout)="isHovered = false"
    >
      <nb-icon
        pack="fci"
        [status]="isHovered ? 'control' : 'primary'"
        [icon]="searchIcon"
      ></nb-icon>
    </div>
    <!-- <app-top-navigation
      (byTopNavDataLoad)="onTopNavDataLoad($event)"
      class="w-100"
    ></app-top-navigation> -->
  </nb-layout-header>
  <nb-sidebar
    tag="main"
    id="sidebar"
    state="compacted"
    [ngClass]="{ 'shadow-none main': 1, transition: 1, collapsed: 1 }"
  >
    <!-- Contains the hamburger icon and the Facets log -->
    <nb-sidebar-header>
      <div style="cursor: pointer">
        <a
          [routerLink]="['/home']"
          (click)="onClickHandleLogo('LEFT_NAV_LOGO')"
        >
          <img
            style="position: absolute"
            [ngStyle]="{
              left: themeName === 'mercedes' ? '2px' : '13px',
              width: themeName === 'mercedes' ? '50px' : 'unset',
              'margin-top': themeName === 'mercedes' ? '-0.5rem' : '0'
            }"
            id="facets-sidebar-logo"
            alt="Logo"
            [src]="sidebarLogoLink"
          />
        </a>
      </div>
    </nb-sidebar-header>

    <!-- Contains the main menu for the app: Projects, Audit Logs and settings -->
    <app-sidebar-v2></app-sidebar-v2>

    <!-- Contains the footer elements: Reference Links, Invite User, Billing section, Help Center, My Account -->
    <nb-sidebar-footer>
      <!-- Reference Links -->
      <div
        *ngIf="referenceQuickLinks?.length"
        #referenceMenuPopover="nbPopover"
        [nbPopover]="referenceLinksRef"
        nbPopoverPlacement="right"
        nbPopoverTrigger="click"
        class="referenceSidebarMenuItem pb-4"
      >
        <nb-icon
          icon="references"
          pack="fci"
          [ngClass]="{
            'menu-icon': 1
          }"
          style="color: #bed0e4 !important"
        ></nb-icon>
      </div>

      <!-- Billing -->
      <nb-menu tag="footerMenu" [items]="footerItems" class="mb-4"> </nb-menu>

      <!-- Invite User -->
      <div
        class="helpCenterSidebarMenuItem mb-3 pb-3"
        nbTooltip="Invite Member"
        (click)="openInviteUser()"
      >
        <nb-icon
          icon="user-invite"
          pack="fci"
          [ngClass]="{
            'menu-icon': 1
          }"
          style="color: #bed0e4 !important"
        ></nb-icon>
      </div>

      <!-- Help Center -->
      <div
        class="helpCenterSidebarMenuItem"
        (click)="onClickRaiseTicket()"
        nbTooltip="Raise a Ticket"
        nbTooltipPlacement="bottom"
        *ngIf="!featureFlagService?.showExternalDoc"
      >
        <nb-icon
          icon="file-error-icon"
          pack="fci"
          [ngClass]="{
            'menu-icon': 1
          }"
          style="color: #bed0e4 !important"
        ></nb-icon>
      </div>

      <div
        #helpCenterMenuPopover="nbPopover"
        [nbPopover]="helpCenterTemplateRef"
        nbPopoverPlacement="right"
        nbPopoverTrigger="click"
        class="helpCenterSidebarMenuItem"
        (click)="onClickHelp()"
        *ngIf="featureFlagService?.showExternalDoc"
      >
        <nb-icon
          icon="question-circle-outlined"
          pack="fci"
          [ngClass]="{
            'menu-icon': 1
          }"
          style="color: #bed0e4 !important"
        ></nb-icon>
      </div>

      <!-- My Account-->
      <app-smooth-height [trigger]="userName">
        <div
          id="userSidebarProfile"
          *ngIf="userName"
          style="margin-top: 0.8rem"
          [ngClass]="{
            'set-margin-to-user-icon': billingService?.showBillingBanner
          }"
        >
          <div
            #myAccountMenuPopover="nbPopover"
            [nbPopover]="myAccountOptionsTemplateRef"
            nbPopoverPlacement="right"
            nbPopoverTrigger="click"
          >
            <nb-user
              [ngClass]="{
                'main-nb-user-component': 1,
                'minimized-profile-icon': 1
              }"
              [name]="userInitials"
              [picture]="user?.attributes?.picture"
              [showInitials]="true"
              [showTitle]="false"
              [onlyPicture]="true"
              [class.pl-2]="true"
              size="small"
            ></nb-user>
          </div>
        </div>
      </app-smooth-height>
    </nb-sidebar-footer>
  </nb-sidebar>

  <!-- Container where the main app is rendered -->
  <nb-layout-column
    [ngStyle]="{
      'max-height': showGlobalSpinner ? '90vh' : '100%',
      'pointer-events': dragging ? 'none' : 'initial'
    }"
  >
    <div
      style="background-color: rgba(255, 255, 255, 0.7)"
      [ngStyle]="{ display: showGlobalSpinner ? 'flex' : 'none' }"
      [nbSpinner]="globalLoaderGifName ? false : showGlobalSpinner"
      class="custom-spinner-parent"
    >
      <img
        class="custom-spinner"
        [src]="globalLoaderGifName"
        *ngIf="globalLoaderGifName"
      />
    </div>

    <!-- <div
      style="background-color: rgba(255, 255, 255, 0.7)"
      [ngStyle]="{ display: showGlobalSpinner ? 'block' : 'none' }"
      [nbSpinner]="showGlobalSpinner"
      class="custom-spinner-parent"
    >
    </div> -->
    <ng-container *ngIf="userService?.userLoaded">
      <router-outlet></router-outlet>
    </ng-container>
  </nb-layout-column>
</nb-layout>

<ng-template #logoutTemplate let-ref="dialogRef">
  <nb-card>
    <nb-card-body> Are you sure you want to log out? </nb-card-body>
    <nb-card-footer>
      <button nbButton status="primary" size="small" (click)="logout()">
        Logout
      </button>
      <button
        nbButton
        ghost
        class="ml-3"
        size="small"
        (click)="onClickHandleCancel(ref)"
      >
        Cancel
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #referenceLinksRef let-ref="dialogRef">
  <nb-menu
    tag="sidebar-help-center-menu"
    [items]="referenceQuickLinks"
    class="sidebar-quick-links-menu"
    (click)="referenceMenuPopover?.hide()"
  ></nb-menu>
</ng-template>

<ng-template #searchTemplate let-ref="dialogRef">
  <app-search [ref]="ref"></app-search>
</ng-template>

<ng-template #myAccountOptionsTemplateRef let-ref="dialogRef">
  <nb-menu
    tag="sidebar-my-account-menu"
    [items]="myAccountQuickLinks"
    class="sidebar-quick-links-menu"
  ></nb-menu>
</ng-template>

<ng-template #inviteUserTemplateRef let-ref="dialogRef">
  <app-invite-user [ref]="ref"></app-invite-user>
</ng-template>

<ng-template #helpCenterTemplateRef let-ref="dialogRef">
  <nb-menu
    tag="sidebar-help-center-menu"
    [items]="helpCenterQuickLinks"
    class="sidebar-quick-links-menu"
    (click)="this.helpCenterMenuPopover?.hide()"
  ></nb-menu>
</ng-template>

<app-token-expiry-global-modal></app-token-expiry-global-modal>

<app-custom-toast></app-custom-toast>

<app-onboarding></app-onboarding>
